import operatorsFilter from './filterTourProductsByAdditionalFilters/operatorsFilter';
// import productTypeFilter from './filterTourProductsByAdditionalFilters/productTypeFilter';
// import isExclusiveFilter from './filterTourProductsByAdditionalFilters/isExclusiveFilter';

export default (filters, tourProducts) => {
    const availableFilters = [{
        filterName: 'operators',
        implementation: operatorsFilter,
    }
    ];

    return _.filter(tourProducts, (tourProduct) => {
        for (let i = 0; i < availableFilters.length; i++) {
            const availableFilter = availableFilters[i];
            if (!availableFilter.implementation(tourProduct, filters.get(availableFilter.filterName))) {
                return false;
            }
        }
        return true;
    });
};
